export default __webpack_public_path__ + "static/media/incubator.29c5e6c5.svg";